import Flatpickr from 'stimulus-flatpickr'

// you can also import a translation file
import { Japanese } from 'flatpickr/dist/l10n/ja.js'

// import a theme (could be in your main CSS entry too...)
// import 'flatpickr/dist/themes/dark.css'
import 'flatpickr/dist/flatpickr.css'

// create a new Stimulus controller by extending stimulus-flatpickr wrapper controller
export default class extends Flatpickr {
  static values = {
    hasTime: Boolean
  }

  initialize() {
    // sets your language (you can also set some global setting for all time pickers)
    this.config = {
      locale: Japanese,
      dateFormat: (this.hasTimeValue ? "Y/m/d H:i" : "Y/m/d"),
      enableTime: this.hasTimeValue,
    }
  }

  setDate() {
    if (this.fp) {
      this.fp.setDate(this.element.value, false)
    }
  }
}
